<template>
  <va-show-layout>
    <va-show :item="item">
      <v-row justify="center">
        <v-col sm="6">
          <base-material-card>
            <template v-slot:heading>
              <div class="display-2">
                {{ title }}
              </div>
            </template>
            <v-card-text>
              <va-field source="mws_configuration_id" ></va-field>
              <va-field source="parent_id" ></va-field>
              <va-field source="name" ></va-field>
              <va-field source="asin" ></va-field>
              <va-field source="sku" ></va-field>
              <va-field source="fn_sku" ></va-field>
              <va-field source="qty" ></va-field>
              <va-field source="row_total" ></va-field>
            </v-card-text>
          </base-material-card>
        </v-col>
      </v-row>
    </va-show>
  </va-show-layout>
</template>

<script>
export default {
  props: ["title", "item"],
};
</script>
